import { render, staticRenderFns } from "./payment-slip.vue?vue&type=template&id=0c4dd22c&"
import script from "./payment-slip.vue?vue&type=script&lang=js&"
export * from "./payment-slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports